import { createTheme, PaletteMode } from '@mui/material';
import { getPaletteOptions } from './palette';
import { getTypography } from './typography';
import { mixins } from './mixins';
import { components } from './component-overrides';
import { addGlobalStyles } from './global-styles';
import type {} from '@mui/x-date-pickers-pro/themeAugmentation';

/**
 * Gets theme used by all components for the provided mode. For more details, see:
 *   - Base colors, typography, sizing - go/chrono-ui-theme
 *   - Material UI defaults: https://material-ui.com/customization/default-theme/
 *   - Material UI variables: https://material-ui.com/customization/theming/#theme-configuration-variables
 *   - Material UI global overrides and default props: https://material-ui.com/customization/globals/#css
 *
 * Need to reinstantiate the theme everytime to support switching between light and dark themes
 * https://github.com/mui-org/material-ui/issues/18831
 */
export function getTheme(mode: PaletteMode, applicationRoot?: string) {
  const theme = createTheme({
    palette: getPaletteOptions(mode),
    typography: getTypography(),
    mixins,
    components,
  });
  addGlobalStyles(theme, applicationRoot);
  return theme;
}
